// Recovered compiled webpack factory 54498. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { t: () => i });
  var r = a(12115),
    n = a(85396);
  function i() {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "/sign-in",
      [t, a] = (0, r.useState)(e);
    return (
      (0, r.useEffect)(() => {
        a((0, n.kq)(e));
      }, [e]),
      t
    );
  }
}
